module.exports = __webpack_public_path__ + "img/clip-climb.73590393.png";